import { createFileRoute } from "@tanstack/react-router";
import { localeUrl } from "@/lib/seo";
import {
  localizedMetaLoader,
  type LocalizedMetaHeadContext,
} from "@/lib/route-head";
import { LinkAccountsPage } from "@/components/link-accounts-page";
// Meta lives in its own module: importing it from the page component would
// pull the whole page into the entry chunk (loader/head() code is not split).
import { PAGE_TITLE, PAGE_DESC, bankSyncHeadMeta } from "@/components/link-accounts-meta";
import { linkAccountsFaqs } from "@/components/link-accounts-content";
import type { FaqEntry } from "@/lib/jsonld";
import { BANK_SYNC_PATH } from "@/config/canonical-aliases";

interface BankSyncLoaderData {
  pageTitle: string;
  pageDesc: string;
  faqs: FaqEntry[];
}

// Backward-compatibility alias (locale-prefixed). Canonicalizes to
// `/<locale>/bank-sync`; see src/routes/($locale)/link-accounts.tsx for the
// rationale.
export const Route = createFileRoute("/$locale/link-accounts")({
  loader: localizedMetaLoader(
    "linkAccounts.meta.title",
    "linkAccounts.meta.description",
    (messages) => ({ faqs: linkAccountsFaqs(messages) }),
  ),
  head: ({ params, loaderData }: LocalizedMetaHeadContext & { loaderData?: Partial<BankSyncLoaderData> }) =>
    bankSyncHeadMeta({
      locale: params.locale,
      title: loaderData?.pageTitle ?? PAGE_TITLE,
      desc: loaderData?.pageDesc ?? PAGE_DESC,
      canonicalUrl: localeUrl(params.locale, BANK_SYNC_PATH),
      faqs: loaderData?.faqs,
    }),
  component: LinkAccountsPage,
});
